import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TopNavOverview } from './TopNavOverview';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Home page entry point.
 * Reads dashboard_layout from user_preferences:
 *   'overview' or 'detailed' → TopNavOverview (home_view_mode localStorage
 *     controls tile vs list view within the component)
 *   'minimal' → redirect to /dashboard/feeds (Feeds-first mode)
 */
export function TopNavDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.id) return;
    supabase
      .from('user_preferences')
      .select('dashboard_layout')
      .eq('user_id', user.id)
      .maybeSingle()
      .then(({ data }) => {
        if ((data as any)?.dashboard_layout === 'minimal') {
          navigate('/dashboard/feeds', { replace: true });
        }
      });
  }, [user?.id, navigate]);

  return <TopNavOverview />;
}

export default TopNavDashboard;
